var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "cvx",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "evpaint0_linear",
    x1: 22.8952,
    y1: 5.0985,
    x2: 4.0445,
    y2: 34.5497,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.630801, 0, 0, 0.630801, 4.645676, 3.26105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1682FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#60D8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FCA75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A5A"
  })))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    cx: 16,
    cy: 16,
    r: 16
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 25.188 13.502 L 25.188 8.502 L 22.688 8.502 L 22.688 6.002 L 17.689 6.002 L 17.689 3.502 L 12.689 3.502 L 12.689 6.002 L 7.689 6.002 L 7.689 8.502 L 5.189 8.502 L 5.189 23.501 L 7.689 23.501 L 7.689 26.001 L 12.689 26.001 L 12.689 28.5 L 17.688 28.5 L 17.688 26.001 L 22.688 26.001 L 22.688 23.501 L 25.188 23.501 L 25.188 18.501 L 20.189 18.501 L 20.189 21.001 L 17.689 21.001 L 17.689 23.501 L 12.689 23.501 L 12.689 21.001 L 10.191 21.001 L 10.191 11.002 L 12.691 11.002 L 12.691 8.502 L 17.69 8.502 L 17.69 11.002 L 20.19 11.002 L 20.19 13.502 L 25.188 13.502 Z",
    fill: "url(#evpaint0_linear)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.689,
    y: 8.376,
    width: 1.741,
    height: 2.625,
    fill: "#1682FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.685,
    width: 1.741,
    height: 2.625,
    fill: "#1682FE",
    y: 3.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.687,
    y: 6,
    width: 1.741,
    height: 2.625,
    fill: "#60D8A4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.186,
    y: 16,
    width: 1.759,
    height: 7.499,
    fill: "#F4BB3B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.186,
    y: 8.502,
    width: 1.759,
    height: 7.499,
    fill: "#60D8A4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.187,
    y: 10.875,
    width: 1.741,
    height: 2.625,
    fill: "#1682FE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.186,
    y: 18.5,
    width: 1.741,
    height: 2.625,
    fill: "#FF5A5A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.689,
    y: 21,
    width: 1.741,
    height: 2.625,
    fill: "#FF5A5A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.686,
    y: 25.874,
    width: 1.741,
    height: 2.625,
    fill: "#FF5A5A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.686,
    y: 23.375,
    width: 1.741,
    height: 2.625,
    fill: "#F4BB3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 26.814 13.5 L 26.814 8.5 L 24.313 8.5 L 24.313 6 L 19.314 6 L 19.314 3.5 L 14.314 3.5 L 14.314 6 L 9.314 6 L 9.314 8.5 L 6.813 8.5 L 6.813 23.5 L 9.313 23.5 L 9.313 26 L 14.312 26 L 14.312 28.499 L 19.312 28.499 L 19.312 26 L 24.313 26 L 24.313 23.5 L 26.814 23.5 L 26.814 18.5 L 21.814 18.5 L 21.814 21 L 19.314 21 L 19.314 23.5 L 14.314 23.5 L 14.314 21 L 11.814 21 L 11.814 11 L 14.314 11 L 14.314 8.5 L 19.314 8.5 L 19.314 11 L 21.814 11 L 21.814 13.5 L 26.814 13.5 Z",
    fill: "#3A3A3A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvx);
export default __webpack_public_path__ + "static/media/CVX.f76f7617.svg";
export { ForwardRef as ReactComponent };